module.exports = __webpack_public_path__ + "static/img/about_h5bg_10_zh.f041083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_10_zh.png
// module id = D3LE
// module chunks = 34